<script lang="ts">
  import { backOut } from 'svelte/easing';
  import { Tween } from 'svelte/motion';

  type Props = {
    stars: number;
    count?: number;
    width: number;
    active: boolean;
    fullClear?: boolean;
  };
  const props: Props = $props();
  const s = new Tween(props.width, { easing: backOut });
  const c = new Tween(0, { duration: 200 });
  $effect(() => {
    s.target = props.width;
    if (props.count !== undefined) {
      c.target = props.count;
    }
  });
</script>

<div class="bar-container" style="--row: {props.stars + 1}">
  <div
    class="bar"
    class:active={props.active}
    class:fullClear={props.fullClear}
    style:width="{s.current}px"
    style={s.current === 0 ? 'border-width: 0' : ''}
  ></div>
  {#if props.count != undefined}
    <span class="count" class:active={props.active}>
      {Math.round(c.current)}
    </span>
  {/if}
</div>

<style lang="scss">
  @use 'sass:color';
  @use '../theme/theme';
  .bar-container {
    grid-row: var(--row) / calc(var(--row) + 1);
    grid-column: bar;
    position: relative;
    color: white;
    display: flex;
    align-items: center;
  }
  .bar {
    position: absolute;
    background-color: theme.$star;
    border: 1px solid color.scale(theme.$star, $lightness: -20%);
    height: 1.5em;
    border-radius: 4px;
    width: var(--bar-width);
    :global(html.dark-mode) & {
      border: none;
      border-color: color.scale(theme.$star, $lightness: -40%);
    }
    &:not(.active) {
      background-color: color.scale(theme.$star, $lightness: 40%);
      border-color: color.scale(theme.$star, $lightness: 20%);
      &.fullClear {
        background-color: color.scale(theme.$star-bonus, $lightness: 40%);
        border-color: color.scale(theme.$star-bonus, $lightness: 20%);
      }
      :global(html.dark-mode) & {
        border: none;
        background-color: color.scale(theme.$star, $lightness: -40%);
        border-color: color.scale(theme.$star, $lightness: -60%);
        &.fullClear {
          background-color: color.scale(theme.$star-bonus, $lightness: -40%);
          border-color: color.scale(theme.$star-bonus, $lightness: -60%);
        }
      }
    }
    &.fullClear {
      background-color: theme.$star-bonus;
      border: 1px solid color.scale(theme.$star-bonus, $lightness: -40%);
    }
  }
  .count {
    z-index: 1;
    font-family: monospace;
    text-align: left;
    padding-left: 0.2em;
    color: black;
    :global(html.dark-mode) &:not(.active) {
      color: white;
    }
    &.active {
      font-weight: bold;
    }
  }
</style>
